import { ActionsFromHostedAppToTVPackage } from '../contract/CommunicationContract';

export const postMessageToParent = (
  action: ActionsFromHostedAppToTVPackage
) => {
  window.parent.postMessage(action, '*');
};
